import { CalibrationConfirmInvoiceDeviceModel } from '../Interface/CalibrationConfirmInvoice_Interface';
import { calculateInvoiceTotals, InvoiceTotals } from './invoice-totals';

export interface CalibrationInvoiceTotals extends InvoiceTotals {
  baseDevicesTotal: number;
  managerIncreaseTotal: number;
  additionalIncreaseTotal: number;
  devicesTotal: number;
  siteDevicesTotal: number;
  labDevicesTotal: number;
  serviceCost: number;
}

export function calculateCalibrationTotals(details: CalibrationConfirmInvoiceDeviceModel[], service: number,
  discount: number, vat: number): CalibrationInvoiceTotals {
  let baseDevicesTotal = 0, managerIncreaseTotal = 0, additionalIncreaseTotal = 0;
  let siteDevicesTotal = 0, labDevicesTotal = 0;
  for (const item of details) {
    const tariff = Number(item.tariff) || 0;
    const manager = Number(item.incRailModir) || 0;
    const unit = tariff + manager;
    const additional = (Number(item.incRail) || 0) + unit * (Number(item.incRailPercent) || 0) / 100;
    baseDevicesTotal += tariff;
    managerIncreaseTotal += manager;
    additionalIncreaseTotal += additional;
    if (item.locationId === 1) siteDevicesTotal += unit + additional;
    else labDevicesTotal += unit + additional;
  }
  const devicesTotal = baseDevicesTotal + managerIncreaseTotal + additionalIncreaseTotal;
  const serviceCost = Number(service) || 0;
  return { ...calculateInvoiceTotals(devicesTotal + serviceCost, discount, vat),
    baseDevicesTotal, managerIncreaseTotal, additionalIncreaseTotal, devicesTotal,
    siteDevicesTotal, labDevicesTotal, serviceCost };
}
